// extracted by mini-css-extract-plugin
export default {"badge":"InvoiceStatusBadge_badge__wsiO3"};